import { effects as fx } from 'redux-saga';

import {
  IPardotSendNewUserPayload, ISendPardotNewsletterSignupPayload,
  sendNewsletterSignup, sendNewUser
} from '../../pardot/actions';
import { newsletterSignupEndpoint, newUserEndpoint } from '../../pardot/endpoints';

function* watchForSendNewUser() {
  const { payload }: { payload: IPardotSendNewUserPayload } = yield fx.take(sendNewUser);
  // This is simply a field that needs to be set in Pardot to differentiate leads
  // that have accounts and those that don't
  payload.has_account = true;

  const body = formBodyFromObject(payload);

  createHiddenIFrame(newUserEndpoint + '?' + body);
}

function* watchForSendNewsletterSignup() {
  const { payload }: { payload: ISendPardotNewsletterSignupPayload } = yield fx.take(sendNewsletterSignup);
  const body = formBodyFromObject(payload);
  createHiddenIFrame(newsletterSignupEndpoint + '?' + body);
}

function formBodyFromObject(payload) {
  return Object
    .keys(payload)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]))
    .join('&');
}

function createHiddenIFrame(url) {
  // @ts-ignore
  if (!isProduction) {
    console.log('Skipping sending of Pardot event since not in production.');
    return;
  }
  try {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '1px';
    iframe.height = '1px';
    iframe.style.zIndex = '0';
    iframe.style.position = 'absolute';
    iframe.style.left = '0';
    iframe.style.top = '0';
    document.body.appendChild(iframe);
  } catch (e) {
    console.error(e);
  }
}

export function* init() {
  yield fx.all([
    fx.call(watchForSendNewUser),
    fx.call(watchForSendNewsletterSignup),
  ]);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/pardot.ts